// payload.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PayloadGuard implements CanActivate {
  
  constructor(private router: Router) {}
  
  canActivate(): boolean {
    // Verificar si existe el payload en localStorage
    const payload = localStorage.getItem('payload');
    
    if (payload && payload !== 'null' && payload !== 'undefined') {
      // Hay payload, permitir acceso
      return true;
    }
    
    // No hay payload, redirigir a home
    this.router.navigate(['/home']);
    return false;
  }
}